module.exports = __webpack_public_path__ + "media/images/emblems/Ligerz-coat_of_arms-d45750baf4670f2e98a35afb9974177f.svg";